import * as React from "react";

export const SvgCamera = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} fill="none" {...props}>
		<circle cx={13} cy={13} r={12} fill="#E9E8E8" stroke="#fff" strokeWidth={1.5} />
		<path
			fill="#A8A8A8"
			d="M14.935 13.808A1.937 1.937 0 0 1 13 15.744a1.937 1.937 0 0 1-1.935-1.936c0-1.067.868-1.935 1.935-1.935 1.067 0 1.935.869 1.935 1.935ZM19 11.06v5.497c0 .733-.594 1.327-1.327 1.327H8.327A1.327 1.327 0 0 1 7 16.557V11.06c0-.732.594-1.327 1.327-1.327h1.632v-.459c0-.64.52-1.16 1.161-1.16h3.76c.641 0 1.161.52 1.161 1.16v.46h1.632c.733 0 1.327.594 1.327 1.326Zm-3.07 2.748a2.934 2.934 0 0 0-2.93-2.93 2.934 2.934 0 0 0-2.93 2.93 2.934 2.934 0 0 0 2.93 2.93 2.934 2.934 0 0 0 2.93-2.93Z"
		/>
	</svg>
);
